module.exports = __webpack_public_path__ + "img/option_delete.f5d307ff.svg";